var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      !_vm.topNav
        ? _c("breadcrumb", {
            staticClass: "breadcrumb-container",
            attrs: { id: "breadcrumb-container" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.topNav
        ? _c("top-nav", {
            staticClass: "topmenu-container",
            attrs: { id: "topmenu-container" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-select",
                  {
                    staticStyle: { float: "left" },
                    attrs: {
                      size: "mini",
                      clearable: "",
                      placeholder: _vm.$t("qhyy"),
                    },
                    on: { change: _vm.switchLanguar },
                    model: {
                      value: _vm.nowLanguar,
                      callback: function ($$v) {
                        _vm.nowLanguar = $$v
                      },
                      expression: "nowLanguar",
                    },
                  },
                  _vm._l(_vm.languarList, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.value, value: item.lang },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    staticStyle: { height: "25px", "margin-top": "-42px" },
                    attrs: { value: _vm.infoNum.recharge_number },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          display: "block",
                          cursor: "pointer",
                          "line-height": "36px",
                          opacity: ".5",
                          "margin-left": "10px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showNoteAll(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("cz")) + "\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    staticStyle: { height: "25px", "margin-top": "-42px" },
                    attrs: { value: _vm.infoNum.withdraw_number },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          display: "block",
                          cursor: "pointer",
                          "line-height": "36px",
                          opacity: ".5",
                          "margin-left": "10px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showNoteAll(2)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tixian")) + "\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    staticStyle: {
                      height: "25px",
                      "margin-top": "-42px",
                      "margin-left": "10px",
                    },
                    attrs: { value: _vm.infoNum.auth_number },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          display: "block",
                          cursor: "pointer",
                          "line-height": "36px",
                          opacity: ".5",
                          "margin-left": "10px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showNoteAll(3)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("shiming")) + "\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    staticStyle: {
                      height: "25px",
                      "margin-top": "-42px",
                      "margin-left": "10px",
                    },
                    attrs: { value: _vm.infoNum.order_number },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          display: "block",
                          cursor: "pointer",
                          "line-height": "36px",
                          opacity: ".5",
                          "margin-left": "10px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showNoteAll(4)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("dingdan")) + "\n        ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "item",
                    staticStyle: { height: "25px", "margin-top": "-42px" },
                    attrs: { value: _vm.infoNum.user_on_line_number },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          display: "block",
                          cursor: "pointer",
                          "line-height": "36px",
                          opacity: ".5",
                          "margin-left": "20px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("onlines")) + "\n        ")]
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _vm._v("\n        " + _vm._s(_vm.JavaInfo.realName)),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(_vm._s(_vm.$t("homeZy"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isPhone
                    ? _c(
                        "router-link",
                        { attrs: { to: { path: "/maintain/user" } } },
                        [
                          _c("el-dropdown-item", [
                            _vm._v(_vm._s(_vm.$t("grzx"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("tcdl")))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("xxzx"),
            visible: _vm.showVisible,
            top: "8vh",
            "append-to-body": true,
            width: "70%",
          },
          on: {
            close: function ($event) {
              _vm.showVisible = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "info-message" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { staticClass: "left-area", attrs: { span: 4 } },
                    [
                      _c("ul", { staticClass: "info-list" }, [
                        _c(
                          "li",
                          {
                            class: { active: _vm.currIndex == 1 },
                            on: {
                              click: function ($event) {
                                return _vm.goList(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("czxx")) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.currIndex == 2 },
                            on: {
                              click: function ($event) {
                                return _vm.goList(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("tixianxx")) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.currIndex == 3 },
                            on: {
                              click: function ($event) {
                                return _vm.goList(3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("shimingxx")) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.currIndex == 4 },
                            on: {
                              click: function ($event) {
                                return _vm.goList(4)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dingdanxx")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 19, offset: 1 } }, [
                    _c(
                      "div",
                      { staticClass: "flex-justify tag-status" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.getWaitInfo()
                              },
                            },
                            model: {
                              value: _vm.singleStatus,
                              callback: function ($$v) {
                                _vm.singleStatus = $$v
                              },
                              expression: "singleStatus",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "" } }, [
                              _vm._v(_vm._s(_vm.$t("allXX"))),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(_vm._s(_vm.$t("jxswd"))),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("jxsyd"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "wait-list" },
                      _vm._l(_vm.tableData.data, function (item, index) {
                        return _c("li", { key: index }, [
                          _c("p", { staticClass: "wait-title" }, [
                            _vm._v(
                              "\n                \n                " +
                                _vm._s(_vm.setType(item.type)) +
                                _vm._s(_vm.$t("dsh")) +
                                _vm._s(_vm.$t("xxtz")) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "wait-text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.explain) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-top": "10px",
                                  "font-size": "13px",
                                  "line-height": "15px",
                                  "text-align": "center",
                                  padding: "5px",
                                  width: "92px",
                                  "border-radius": "5px",
                                  color: "#0256FF",
                                  border: "1px solid #0256FF",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.settingRead(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("shcl")) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-top": "10px",
                                  "font-size": "13px",
                                  "line-height": "15px",
                                  "margin-left": "10px",
                                  "text-align": "center",
                                  padding: "5px",
                                  width: "92px",
                                  "border-radius": "5px",
                                  color: "#ffffff",
                                  border: "1px solid #0256FF",
                                  background: "#0256FF",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("ljck")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "block" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "page-sizes": [15, 30, 45, 60],
                            "page-size": _vm.userFrom.limit,
                            "current-page": _vm.userFrom.page,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.tableData.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("guanbi")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("audio", { ref: "audioPlayerAL", on: { ended: _vm.onAudioEnded } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }